import { Construction } from "lucide-react";
import React from "react";
import { BaseSelectorProps } from "./BaseSelector";

export const NotImplementedSelector: React.FC<BaseSelectorProps> = ({
  connection,
}) => (
  <div className="flex items-center justify-center h-full text-muted-foreground">
    <div className="text-center w-full px-4">
      <Construction className="h-8 w-8 mx-auto mb-2" />
      <p className="text-center text-sm">
        Record selection for {connection.integration_name} is coming soon!
      </p>
    </div>
  </div>
);
